import React from 'react';

const OnboardingStep4 = ({ onNext, onBack }) => {
    return (
        <div className="wizard-step">
            <div className="step-header">
                <h2>Import Contacts</h2>
                <p>Add your contacts <span className="optional-label">(optional - you can do this later)</span></p>
            </div>

            <div style={{ padding: '20px', background: 'var(--bg-secondary)', borderRadius: '8px', marginBottom: '20px' }}>
                <h4 style={{ color: 'var(--text-primary)' }}>You can import contacts in two ways:</h4>
                <ol style={{ marginLeft: '20px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                    <li>
                        <strong>Skip for now</strong> and use the Contacts menu after setup is complete
                    </li>
                    <li>
                        <strong>After onboarding</strong>, navigate to Contacts → Import Contacts to use our CSV import wizard
                    </li>
                </ol>

                <div style={{ marginTop: '20px', padding: '15px', background: 'var(--bg-warning)', borderRadius: '4px', border: '1px solid var(--border-color)' }}>
                    <strong style={{ color: 'var(--text-primary)' }}>💡 Tip:</strong>
                    <span style={{ color: 'var(--text-secondary)' }}> Most users find it easier to complete the basic setup first, then import contacts from the main application. This way you can take your time to prepare your contact list properly.</span>
                </div>
            </div>

            <div style={{ marginTop: '30px' }}>
                <h4 style={{ color: 'var(--text-primary)' }}>What you'll need for contact import:</h4>
                <ul style={{ lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                    <li>CSV file exported from Outlook, Gmail, or Excel</li>
                    <li>Contact information including name, company, email, phone</li>
                    <li>Optional: Contact type (contractor, engineering firm, etc.)</li>
                    <li>Optional: City/organization assignment</li>
                </ul>
            </div>

            <div style={{ marginTop: '30px', padding: '15px', background: 'var(--bg-info)', borderRadius: '4px', border: '1px solid var(--border-color)' }}>
                <strong style={{ color: 'var(--text-primary)' }}>📥 Download Sample Template:</strong>
                <p style={{ margin: '10px 0 0 0', color: 'var(--text-secondary)' }}>
                    After setup, you can download a sample CSV template from the Contacts page to see the expected format.
                </p>
            </div>

            <div className="step-footer">
                <button onClick={onBack} className="btn-back">
                    ← Back
                </button>
                <button onClick={onNext} className="btn-next">
                    Next (Skip Contacts) →
                </button>
            </div>
        </div>
    );
};

export default OnboardingStep4;

